const modalId = {
  NEW_APPOINTMENT: 'newAppointment',
  EDIT_APPOINTMENT: 'editAppointment',
  CHECKOUT_APPOINTMENT: 'checkoutAppointment',

  NEW_CLIENT: 'newClient',
  EDIT_CLIENT: 'editClient',

  NEW_STAFF: 'newStaff',
  EDIT_STAFF: 'editStaff',

  NEW_SERVICE: 'newService',
  NEW_SERVICE_CATEGORY: 'newServiceCategory',
  EDIT_SERVICE: 'editService',
  EDIT_SERVICE_CATEGORY: 'editServiceCategory',

  NEW_PRODUCT: 'newProduct',
  NEW_PRODUCT_CATEGORY: 'newProductCategory',
  EDIT_PRODUCT: 'editProduct',
  EDIT_PRODUCT_CATEGORY: 'editProductCategory',

  NEW_SALE: 'newSale',
  EDIT_SALE: 'editSale',

  SELECT_ITEM_SALE: 'selectItemSale'
};

export default modalId;
